import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { STUDIO_ACCESS_TIER } from 'Pods/ThreeDStudio/Store/constants'

const PAID_TIERS = new Set([
  STUDIO_ACCESS_TIER.SUBSCRIBED,
  STUDIO_ACCESS_TIER.HAS_CREDITS,
])

// The backend enforces a per-tier concurrent-generation cap
// (Generator::SubscriptionState); the FE mirror arrives as
// subscription.concurrencyCap (pageConfig / run-channel quota broadcasts).
// Until it hydrates, fall back to the legacy single-run limit. The
// concurrent-generation UI ships behind the :enable_multiple_generations
// Flipper flag (isMultipleEnabled), gated on the FRONTEND only: with the flag
// off this hook forces the legacy single-run cap and consumers keep the legacy
// presentation (replaced card, in-progress tooltip, no crown), while the
// backend keeps accepting the real tier caps.
export default function useGenerationConcurrency() {
  const activeRunCount = useThreeDStudioStore(state => state.generation.activeRuns.length)
  const concurrencyCap = useThreeDStudioStore(state => state.subscription.concurrencyCap)
  const studioAccessTier = useThreeDStudioStore(state => state.subscription.studioAccessTier)
  const isMultipleEnabled = useThreeDStudioStore(state => state.subscription.multipleGenerationsEnabled)

  const cap = isMultipleEnabled ? (concurrencyCap ?? 1) : 1
  const isPaidTier = PAID_TIERS.has(studioAccessTier)
  const isCapReached = activeRunCount >= Math.max(cap, 1)

  return { activeRunCount, cap, isCapReached, isPaidTier, isMultipleEnabled }
}
